// 평일 데이터
export const 평일시간 = [
  { id: 1, bus: 7001, 설악출발: '0545', 잠실출발: '0655' },
  { id: 2, bus: 7002, 설악출발: '0615', 잠실출발: '0725' },
  { id: 3, bus: 7001, 설악출발: '0635', 잠실출발: '0745' },
  { id: 4, bus: 7000, 설악출발: '0710', 잠실출발: '0820' },
  { id: 5, bus: 7001, 설악출발: '0745', 잠실출발: '0855' },
  { id: 6, bus: 7001, 설악출발: '0850', 잠실출발: '1000' },
  { id: 7, bus: 7002, 설악출발: '0930', 잠실출발: '1040' },
  { id: 8, bus: 7001, 설악출발: '0950', 잠실출발: '1100' },
  { id: 9, bus: 7001, 설악출발: '1045', 잠실출발: '1155' },
  { id: 10, bus: 7000, 설악출발: '1110', 잠실출발: '1220' },
  { id: 11, bus: 7001, 설악출발: '1200', 잠실출발: '1310' },
  { id: 12, bus: 7002, 설악출발: '1245', 잠실출발: '1355' },
  { id: 13, bus: 7001, 설악출발: '1305', 잠실출발: '1415' },
  { id: 14, bus: 7001, 설악출발: '1355', 잠실출발: '1505' },
  { id: 15, bus: 7000, 설악출발: '1440', 잠실출발: '1550' },
  { id: 16, bus: 7001, 설악출발: '1510', 잠실출발: '1620' },
  { id: 17, bus: 7001, 설악출발: '1605', 잠실출발: '1715' },
  { id: 18, bus: 7002, 설악출발: '1630', 잠실출발: '1740' },
  { id: 19, bus: 7001, 설악출발: '1705', 잠실출발: '1815' },
  { id: 20, bus: 7001, 설악출발: '1815', 잠실출발: '1925' },
  { id: 21, bus: 7000, 설악출발: '1840', 잠실출발: '1950' },
  { id: 22, bus: 7001, 설악출발: '1915', 잠실출발: '2025' },
  { id: 23, bus: 7002, 설악출발: '1945', 잠실출발: '2055' },
  { id: 24, bus: 7001, 설악출발: '2015', 잠실출발: '2125' },
  { id: 25, bus: 7001, 설악출발: '2110', 잠실출발: '2220' },
  { id: 26, bus: 7001, 설악출발: '2210', 잠실출발: '2320' },
  { id: 27, bus: 7000, 설악출발: '2230', 잠실출발: '2340' },
  { id: 28, bus: 7002, 설악출발: '2305', 잠실출발: '2415' },
  { id: 29, bus: 7001, 설악출발: '2335', 잠실출발: '2445' },
  { id: 30, bus: 7001, 설악출발: '2405', 잠실출발: '2515' },
];
// 토요일, 공휴일 데이터
export const 토요일공휴일시간 = [
  { id: 1, bus: 7001, 설악출발: '0540', 잠실출발: '0630' },
  { id: 2, bus: 7002, 설악출발: '0615', 잠실출발: '0725' },
  { id: 3, bus: 7001, 설악출발: '0640', 잠실출발: '0750' },
  { id: 4, bus: 7000, 설악출발: '0710', 잠실출발: '0820' },
  { id: 5, bus: 7001, 설악출발: '0750', 잠실출발: '0900' },
  { id: 6, bus: 7001, 설악출발: '0930', 잠실출발: '1040' },
  { id: 7, bus: 7001, 설악출발: '1020', 잠실출발: '1130' },
  { id: 8, bus: 7002, 설악출발: '1040', 잠실출발: '1150' },
  { id: 9, bus: 7001, 설악출발: '1120', 잠실출발: '1230' },
  { id: 10, bus: 7000, 설악출발: '1220', 잠실출발: '1330' },
  { id: 11, bus: 7001, 설악출발: '1320', 잠실출발: '1430' },
  { id: 12, bus: 7001, 설악출발: '1400', 잠실출발: '1510' },
  { id: 13, bus: 7001, 설악출발: '1500', 잠실출발: '1610' },
  { id: 14, bus: 7002, 설악출발: '1520', 잠실출발: '1630' },
  { id: 15, bus: 7001, 설악출발: '1710', 잠실출발: '1820' },
  { id: 16, bus: 7001, 설악출발: '1740', 잠실출발: '1850' },
  { id: 17, bus: 7000, 설악출발: '1810', 잠실출발: '1920' },
  { id: 18, bus: 7001, 설악출발: '1840', 잠실출발: '1950' },
  { id: 19, bus: 7002, 설악출발: '1920', 잠실출발: '2030' },
  { id: 20, bus: 7001, 설악출발: '2020', 잠실출발: '2130' },
  { id: 21, bus: 7001, 설악출발: '2040', 잠실출발: '2150' },
  { id: 22, bus: 7001, 설악출발: '2130', 잠실출발: '2240' },
  { id: 23, bus: 7000, 설악출발: '2220', 잠실출발: '2330' },
  { id: 24, bus: 7001, 설악출발: '2240', 잠실출발: '2350' },
  { id: 25, bus: 7001, 설악출발: '2310', 잠실출발: '2420' },
  { id: 26, bus: 7001, 설악출발: '2340', 잠실출발: '2450' },
  { id: 27, bus: 7001, 설악출발: '2410', 잠실출발: '2520' },
];

// 일요일 데이터
export const 일요일시간 = [
  { id: 1, bus: 7001, 설악출발: '0540', 잠실출발: '0650' },
  { id: 2, bus: 7002, 설악출발: '0615', 잠실출발: '0725' },
  { id: 3, bus: 7001, 설악출발: '0640', 잠실출발: '0750' },
  { id: 4, bus: 7000, 설악출발: '0710', 잠실출발: '0820' },
  { id: 5, bus: 7001, 설악출발: '0750', 잠실출발: '0900' },
  { id: 6, bus: 7001, 설악출발: '0850', 잠실출발: '1000' },
  { id: 7, bus: 7002, 설악출발: '0940', 잠실출발: '1050' },
  { id: 8, bus: 7001, 설악출발: '1010', 잠실출발: '1120' },
  { id: 9, bus: 7001, 설악출발: '1050', 잠실출발: '1230' },
  { id: 10, bus: 7001, 설악출발: '1210', 잠실출발: '1350' },
  { id: 11, bus: 7000, 설악출발: '1240', 잠실출발: '1430' },
  { id: 12, bus: 7001, 설악출발: '1310', 잠실출발: '1450' },
  { id: 13, bus: 7002, 설악출발: '1340', 잠실출발: '1530' },
  { id: 14, bus: 7001, 설악출발: '1420', 잠실출발: '1600' },
  { id: 15, bus: 7001, 설악출발: '1600', 잠실출발: '1740' },
  { id: 16, bus: 7001, 설악출발: '1640', 잠실출발: '1820' },
  { id: 17, bus: 7000, 설악출발: '1710', 잠실출발: '1900' },
  { id: 18, bus: 7001, 설악출발: '1740', 잠실출발: '1920' },
  { id: 19, bus: 7002, 설악출발: '1810', 잠실출발: '2000' },
  { id: 20, bus: 7001, 설악출발: '1950', 잠실출발: '2130' },
  { id: 21, bus: 7001, 설악출발: '2020', 잠실출발: '2150' },
  { id: 22, bus: 7001, 설악출발: '2120', 잠실출발: '2230' },
  { id: 23, bus: 7001, 설악출발: '2220', 잠실출발: '2330' },
  { id: 24, bus: 7000, 설악출발: '2250', 잠실출발: '2350' },
  { id: 25, bus: 7001, 설악출발: '2310', 잠실출발: '2420' },
  { id: 26, bus: 7001, 설악출발: '2340', 잠실출발: '2450' },
  { id: 27, bus: 7001, 설악출발: '2410', 잠실출발: '2520' },
];

export const STATION_ID = {
  설악: 239000374,
  잠실: 123000049
}

export const STATION_NAME = {
  239000374: '설악',
  123000049: '잠실',
}

export const BUS = {
  7000: {
    id: 239000139,
    routeNumber: 7000,
    department: "가평터미널행",
    staOrderOfSeorak: 39,
  },
  7001: {
    id: 239000140,
    routeNumber: 7001,
    department: "청심병원행",
    staOrderOfSeorak: 10,
  },
  7002: {
    id: 239000141,
    routeNumber: 7002,
    department: "유명산행",
    staOrderOfSeorak: 18,
  }
}